import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Heading from '@components/libraryV2/Heading';
import LinkButton from '@components/libraryV2/LinkButton';
import ThemeText from '@components/libraryV2/ThemeText';
import Well from '@components/libraryV2/Well';

import * as styles from './styles.module.scss';

const IMAGE_MAP = {
  act: ({ alt, className }) => (
    <StaticImage alt={alt} className={className} src="./act.png" width={800} />
  ),
  amc: ({ alt, className }) => (
    <StaticImage alt={alt} className={className} src="./amc.png" width={800} />
  ),
  finra: ({ alt, className }) => (
    <StaticImage alt={alt} className={className} src="./finra.png" width={800} />
  ),
  gre: ({ alt, className }) => (
    <StaticImage alt={alt} className={className} src="./gre.png" width={800} />
  ),
  usmle: ({ alt, className }) => (
    <StaticImage alt={alt} className={className} src="./usmle.png" width={800} />
  ),
  default: ({ alt, className }) => (
    <StaticImage
      alt={alt}
      className={className}
      src="./site-desktop-mobile.png"
      width={800}
    />
  ),
};

const PassGuaranteedCta = (props) => {
  const {
    className,
    exam,
    unlaunched,
    href,
    tagline,
    noGuarantee,
    detailText: passedDetailText,
    secondary,
    type,
  } = props;
  const emphasis = noGuarantee ? null : 'Guaranteed.';

  const destination = unlaunched
    ? 'https://achievable.typeform.com/to/BJc2i3'
    : href || 'https://app.achievable.me/study/achievable/catalog';

  const passText =
    tagline ||
    (exam ? (
      <>
        Pass the <span className={styles.exam}>{exam}</span>.
      </>
    ) : (
      'Ace your exam.'
    ));

  const defaultText = noGuarantee
    ? "Achievable is the best online exam prep course: effective, personalized, and convenient. With Achievable, you'll spend less time studying and hit your target score with confidence."
    : "Achievable is the best online exam prep course: effective, personalized, and convenient. With Achievable, you'll spend less time studying and pass your exam the first time, or your money back.";
  const detailText = passedDetailText || defaultText;
  const alt = `Achievable ${exam || 'course'} dashboard`;
  const Image = IMAGE_MAP[type] || IMAGE_MAP.default;

  return (
    <div className={secondary && styles.secondary}>
      <Well className={styles.layout}>
        <Image alt={alt} className={className} />

        <div className={styles.content}>
          <div className={styles.title}>
            <Heading size="h2">
              {passText} {emphasis ? <ThemeText>{emphasis}</ThemeText> : null}
            </Heading>
          </div>

          <div className={styles.descriptionContainer}>
            <div className={styles.description}>{detailText}</div>
          </div>

          <div className={styles.button}>
            <LinkButton theme="emerald" href={destination}>
              Get started for free <i className="fa-solid fa-arrow-right" />
            </LinkButton>
          </div>
        </div>
      </Well>
    </div>
  );
};

export default PassGuaranteedCta;
